<template>
  <div class="container mt-5">
    <div class="card p-4 shadow-sm mx-auto lote-card" style="max-width: 500px;">
      <h2 class="text-center mb-4">
        <font-awesome-icon icon="fas fa-barcode" class="me-2" />
        Alta de Lote
      </h2>
      <form @submit.prevent="crearLote">
        <!-- Campo Código: se genera automáticamente y es solo de lectura -->
        <div class="mb-3">
          <label for="codigo" class="form-label">Código</label>
          <input
            v-model="codigo"
            type="text"
            id="codigo"
            class="form-control"
            readonly
          />
        </div>
        <!-- Campo Nombre con botón de generación -->
        <div class="mb-3 d-flex align-items-center">
          <div class="flex-grow-1 me-2">
            <label for="nombre" class="form-label">Nombre</label>
            <input
              v-model="nombre"
              type="text"
              id="nombre"
              class="form-control"
              placeholder="Nombre del lote"
              required
            />
          </div>
          <button type="button" class="btn btn-outline-secondary" @click="generarNombre">
            Generar Nombre
          </button>
        </div>
        <!-- Campo Descripción -->
        <div class="mb-3">
          <label for="descripcion" class="form-label">Descripción</label>
          <textarea
            v-model="descripcion"
            id="descripcion"
            class="form-control"
            rows="3"
            placeholder="Descripción del lote"
            
          ></textarea>
        </div>
        <!-- Campo Fecha de Inicio -->
        <div class="mb-3">
          <label for="fecha_inicio" class="form-label">Fecha de Inicio</label>
          <input
            v-model="fecha_inicio"
            type="date"
            id="fecha_inicio"
            class="form-control"
            required
          />
        </div>
        <!-- Otros campos relevantes para un lote se pueden agregar aquí -->
        <button type="submit" class="btn btn-primary w-100">Crear Lote</button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from '@/axios';

export default {
  name: 'AltaLote',
  props: {
    proyecto_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      codigo: '',
      nombre: '',
      descripcion: '',
      fecha_inicio: this.obtenerFechaActual(), // Formato YYYY-MM-DD
      clubActual: this.$store.getters.getClubActual,
    };
  },
  mounted() {
    this.obtenerCodigo();
  },
  methods: {
    async crearLote() {
      try {
        const response = await axios.post('/api/lotes', {
          form: {
            nombre: this.nombre,
            descripcion: this.descripcion,
            fecha_inicio: this.fecha_inicio,
            proyecto_id: this.proyecto_id,
            codigo: this.codigo, // Se envía el código generado
          },
          club_id: this.clubActual.id,
        });

        if (response.status === 201) {
          alert('Lote creado correctamente');

          this.$emit('lote-creado', response.data.lote); // Emitir evento al padre
        }
      } catch (error) {
        console.error('Error al crear el lote:', error);
      }
    },
    obtenerFechaActual() {
      const hoy = new Date();
      return hoy.toISOString().split('T')[0];
    },
    async obtenerCodigo() {
      try {
        // Llama a la API para generar un código único para el lote
        const response = await axios.get(`/api/lote_generar_codigo/${this.clubActual.id}`);
        this.codigo = response.data.codigo;

      } catch (error) {
        console.error('Error al generar código:', error);
      }
    },
    generarNombre() {
      // Lista de nombres base posibles
      const nombresBase = [
        'Aurora', 'Brisa', 'Cumbre', 'Delta', 'Eco', 'Fénix',
        'Globo', 'Horizon', 'Ímpetu', 'Jazmín', 'Karma', 'Llama',
        'Marea', 'Nexo', 'Órbita', 'Pionero', 'Quimera', 'Rayo', 'Sierra', 'Trueno',
        'Urbano', 'Viento', 'Xenón', 'Yate', 'Zenith',
        'Amanecer', 'Brillante', 'Cielo', 'Destello', 'Estrella',
        'Fulgor', 'Galaxia', 'Horizonte', 'Ilusión', 'Júpiter',
            ];
      // Seleccionar un nombre al azar
      const indice = Math.floor(Math.random() * nombresBase.length);
      const nombreBase = nombresBase[indice];
      // Generar un número aleatorio entre 1 y 999
      const numeroAleatorio = Math.floor(Math.random() * 999) + 1;
      // Armar el nombre y asignarlo
      this.nombre = `${nombreBase}-${numeroAleatorio.toString().padStart(3, '0')}`;
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 600px;
}
.lote-card {
  background-color: #ffffff;
  border: none;
  border-radius: 12px;
}
h2 {
  font-size: 1.75rem;
  color: #333;
}
.form-label {
  font-weight: 500;
}
.btn {
  font-weight: bold;
}
</style>
